import { render } from "./ImageViewModal.vue?vue&type=template&id=4f136f6f"
import script from "./ImageViewModal.vue?vue&type=script&lang=js"
export * from "./ImageViewModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__